import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { isMemoriesHost, MEMORIES_GUEST_TOKEN_KEY } from '../utils/memoriesHost';
import { redirectMemoriesToSharedLogin } from '../utils/memoriesAuthBridge';

/**
 * Album pages: signed-in members, or guests who already registered a
 * name/email session via share link / QR (X-Guest-Token in localStorage).
 */
const MemoriesGuestOrUserRoute = ({ children }) => {
  const { user, loading, isTokenExpired } = useAuth();
  const location = useLocation();
  const guestToken = typeof window !== 'undefined'
    ? localStorage.getItem(MEMORIES_GUEST_TOKEN_KEY)
    : null;

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Authenticating...
        </Typography>
      </Box>
    );
  }

  if (guestToken && !user) {
    return children;
  }

  if (!user) {
    if (isMemoriesHost()) {
      redirectMemoriesToSharedLogin(
        `${window.location.origin}${location.pathname}${location.search || ''}`
      );
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress size={40} />
        </Box>
      );
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const token = localStorage.getItem('token');
  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (guestToken) {
      return children;
    }
    if (isMemoriesHost()) {
      redirectMemoriesToSharedLogin(
        `${window.location.origin}${location.pathname}${location.search || ''}`
      );
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress size={40} />
        </Box>
      );
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default MemoriesGuestOrUserRoute;
